import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const auth = localStorage.getItem("challanTokens");

  return auth ? <Outlet /> : <Navigate to="/signin" />;
};

export default PrivateRoute;
